import isAfterDate from './isAfterDate'

export default isAfterDate
